<template>
  <dara-icon-action-content-layout>
    <template #icon>
      <dara-user-link :id="article.user.id">
        <dara-user-badge v-if="badge" :badge="badge" offset-y="5" offset-x="-2" />
        <dara-avatar
          size="lg"
          :source="article.user.profile_pic"
          class="cursor--pointer" />
      </dara-user-link>
    </template>
    <template #main>
      <dara-p>
        <dara-user-link :id="article.user.id" class="color--primary">
          {{ article.user.name }}
        </dara-user-link>
        <span>{{ articleInfo }}</span>
      </dara-p>
      <dara-row class="d-flex align-items-center">
        <dara-col :xs="24" :span="8">
          <dara-rating v-model="avgRatings" :disabled="true" />
        </dara-col>
        <dara-col class="align-item-left ratings">
          <small>( {{ totalRatings }} ) {{ $t('ratings') }}</small>
        </dara-col>
      </dara-row>
    </template>
  </dara-icon-action-content-layout>
</template>

<script>
import { fetchBestWriters, fetchTopReaders, fetchTopWriters } from '@/modules/user/user.service';
import { formatToTimeAgo } from '@/helpers/date';
import { toastError } from '@/services/toastService';
import { translate } from '@/services/translate.service';

import DaraUserBadge from '@/modules/user/components/UserBadge.vue';
import DaraIconActionContentLayout from '@/layouts/IconActionContentLayout.vue';
import DaraUserLink from '@/modules/user/components/UserLink.vue';

export default {
  name: 'ArticleAuthor',
  components: {
    DaraUserBadge,
    DaraIconActionContentLayout,
    DaraUserLink,
  },
  inheritAttrs: false,
  props: {
    article: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      avgRatings: this.article.rating,
      user: this.article.user,
      totalRatings: this.article.amount_of_ratings,
    };
  },
  computed: {
    articleInfo() {
      return ` ${formatToTimeAgo(this.article.created_at)} · ${this.article.reading_time} ${translate('min-read')}`;
    },
    badge() {
      if (this.user.isBestWriter) return 'best-writer';
      if (this.user.isTopWriter) return 'top-writer';
      if (this.user.isTopReader) return 'top-reader';
      return false;
    },
  },
  mounted() {
    this.fetchBestWriter();
    this.fetchTopWriter();
    this.fetchTopReader();
  },
  methods: {
    fetchBestWriter() {
      fetchBestWriters(1)
        .then(data => {
          if (this.user.id === data.id) {
            this.$set(this.user, 'isBestWriter', true);
          }
        })
        .catch(() => {
          toastError(`${translate('error-getting-best-writer')}`);
        });
    },
    fetchTopWriter() {
      fetchTopWriters(1)
        .then(data => {
          if (this.user.id === data.id) {
            this.$set(this.user, 'isTopWriter', true);
          }
        })
        .catch(() => {
          toastError(`${translate('error-getting-top-writer')}`);
        });
    },
    fetchTopReader() {
      fetchTopReaders(1)
        .then(data => {
          if (this.user.id === data.id) {
            this.$set(this.user, 'isTopReader', true);
          }
        })
        .catch(() => {
          toastError(`${translate('error-getting-top-reader')}`);
        });
    },
  },
};
</script>

<style scoped>
  .ratings {
    margin-left: -20px;
    color: gray;
  }
</style>
